define('app/factories/ajax_form_factory',['app/setup', 'app/views/ajax_form_view'], function(takhfifan, ajaxForm) {
  $(function($) {
    var alreadyInit = false;

    if(takhfifan.formKey){
      init();
    }else{
      takhfifan.eventHub.on('formkey', function(formKey) {
        init();
      });
    }

    function init(){
      if(!alreadyInit){
        $('.tkh-ajax-form').each(function() {
          new takhfifan.AjaxForm({
            el: $(this)
          });
        });
        alreadyInit = true;
      }
    }

  });
});

